import { ReactNode } from 'react'
import {
  ReservedHeight,
  PRODUCT_SHOWCASE_HEIGHT,
  DeferredMount,
} from 'src/components/deferredMount'

type ShowcaseWithId = { id: string | number }

type DeferredShowcasesProps<T extends ShowcaseWithId> = {
  /** Vitrines a renderizar. Ausente ou vazia nao produz nada. */
  showcases?: T[]
  /** Altura a reservar por vitrine enquanto ela nao montou. */
  reservedHeight?: ReservedHeight
  /** Como renderizar cada vitrine. */
  children: (showcase: T) => ReactNode
}

/**
 * Renderiza uma lista de vitrines com a montagem adiada ate a aproximacao.
 *
 * Existe para que a chave, o bloco de reserva e a altura fiquem num lugar so:
 * o mesmo trecho aparecia dez vezes em cinco arquivos, e cada copia era uma
 * chance de esquecer a altura ou usar a do componente errado.
 *
 * O mapeamento de propriedades fica no chamador de proposito. Ele nao e
 * uniforme — na busca o bloco do meio usa `name` como titulo e `title` como
 * subtitulo, enquanto os demais usam `title` e `subtitle`. Absorver isso aqui
 * esconderia uma inconsistencia real do codigo.
 *
 * Use apenas em vitrines abaixo da dobra. A primeira vitrine da pagina fica
 * visivel no carregamento, e adiar o que ja esta na tela nao economiza nada —
 * so atrasa o LCP.
 */
export const DeferredShowcases = <T extends ShowcaseWithId>({
  showcases,
  reservedHeight = PRODUCT_SHOWCASE_HEIGHT,
  children,
}: DeferredShowcasesProps<T>) => (
  <>
    {showcases?.map((showcase) => (
      <DeferredMount key={showcase.id} reservedHeight={reservedHeight}>
        {children(showcase)}
      </DeferredMount>
    ))}
  </>
)
